export class AccountingProfitAndLossModel {

  importe_Neto_De_La_Cifra_De_Negocios: number;
  variacion_De_Existencias_De_Productos_Terminados_Y_En_Curso_De_Fabricacion: number;
  trabajos_Realizados_Por_La_Empresa_Para_Su_Activo: number;
  aprovisionamientos: number;
  otros_Ingresos_De_Explotacion: number;
  gastos_De_Personal: number;
  otros_Gastos_De_Explotacion: number;
  amortizacion_Del_Inmovilizado: number;
  imputacion_De_Subvenciones_De_Inmobilizado_No_Financiero_Y_Otras: number;
  excesos_De_Proviciones: number;
  deterioro_Y_Resultado_Por_Enajenaciones_Del_Inmovilizado: number;
  otros_Resultados: number;
  resultado_De_Explotacion: number;
  ingresos_Financieros: number;
  imputacion_De_Subvenciones_Donaciones_Y_Legados_De_Caracter_Financiero: number;
  otros_Ingresos_Financieros: number;
  gastos_Financieros: number;
  variacion_De_Valor_Razonable_En_Instrumentos_Financieros: number;
  diferencias_De_Cambios: number;
  deterioro_Y_Resultado_Por_Enajenaciones_De_Instrumentos_Financieros: number;
  otros_Ingresos_Y_Gastos_De_Caracter_Financiero: number;
  incorporacion_Al_Activo_De_Gastos_Financieros: number;
  ingresos_Financieros_Derivados_De_Convenios_De_Acreedores: number;
  resto_De_Ingresos_Y_Gastos: number;
  resultado_Financiero: number;
  resultado_Antes_De_Impuestos: number;
  impuestos_Sobre_Beneficios: number;
  resultado_Del_Ejercicio: number;

  constructor() {
  }

}
